/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: Dashboard
 * (C) Copyright IBM Corp. 2014, 2021
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

define({
	'dlg_loading': 'Yükleniyor...',
	'dlg_close': 'Kapat',
	'dlg_ok': 'Tamam',
	'dlg_cancel': 'İptal',
	'dlg_back': 'Geri git',
	'dlg_done': 'Bitti',

	// Slider
	'sliderRegionLabel': 'Kaydırıcı denetimi, kaydırıcı tutamaçlarını taşımak için sağ ve sol okları kullanın',
	'sliderHandleLabel': 'Kaydırıcı tutamacı',
	'a11ySliderHandleLabel': 'Kaydırıcı tutamacı %{sliderValue}',
	'sliderInputLabel': 'değer',

	// Side bar
	'sidebarAdd': 'Ekle',
	'clearTextFilterValue': 'Temizle',
	'missingDataSetData': 'Bu veri kümesi için veriler kullanılamıyor. Kaynağa erişim için veri kümesini yenileyin veya sistem yöneticinizle görüşün.',

	// Toolbar
	'toolbarRegionLabel': 'Araç çubuğu',
	'toolbarLabel': '%{labelName}:',
	'toolbarNoValueLabel': '%{labelName}',
	//TextToolbar
	'fontSelect': 'Yazı tipi ailesi',
	'fontSizeSelect': 'Yazı tipi boyutu',
	'fontColorSelect': 'Renk',
	'fontStyle': 'Stil',
	'colorPickerTitle': 'Renk seçme',
	'bold': 'Kalın',
	'italic': 'İtalik',
	'underline': 'Altı çizili',
	'fontAlignment': 'Hizalama',
	'justifyLeft': 'Sola hizala',
	'justifyCenter': 'Ortaya hizala',
	'justifyRight': 'Sağa hizala',
	'insertOrderedList': 'Sıralı Liste',
	'insertUnorderedList': 'Sırasız Liste',
	'fontColorPicker': 'Renk seçici',
	'textWrap': 'Metni kaydır',
	'restore': 'Varsayılanları geri yükle',
	// Top Bottom
	'topbottomNumberOfResultsLabel': 'Sonuç sayısı (%{lower} - %{higher})',
	'topbottomPercentLabel': 'Yüzde (%{lower}% - %{higher}%)',
	'topbottomSelectOption': 'Üst veya alt seçeneği',
	'topbottomOptionLabel': 'Göster',
	'searchByLabel': 'Temel',
	'searchNoMatches': 'Eşleşme bulunamadı',
	'topbottomRankColumnLabel': 'Tabloya bir derece sütunu ekle',
	'topbottomNone': 'Yok',
	'topCount': 'Üst sayı',
	'topPercent': 'Üst değer: %',
	'bottomCount': 'Alt sayı',
	'bottomPercent': 'Alt değer: %',
	'searchColumn': 'Bir sütun bul',
	'searchColumnAriaLabel': 'Bir sütun bulun. Aranacak sütunun adını yazın, ardından sütunu bir listede bulmak için aşağı oku kullanın',
	'searchColumnQualifiedLabel': '%{columnLabel} (%{columnId})',
	'rankColumnLabel': 'Derece (%{columnLabel})',
	'topbottomClearLabel': 'Sıfırla',

	// Format
	'formatAuto': 'Otomatik',
	'formatConvertPercent': 'Ondalık değeri yüzde değerine dönüştür',
	'formatAbbreviate': 'Kısalt',
	'formatUseGrouping': 'Binlik basamak ayırıcı kullan',
	'dateStyle': 'Tarih stili',
	'dateTimeStyle': 'Tarih/Saat stili',
	'formatMissingValueCharactersInfo': 'Eksik değer karakterleri, değer eksik olduğunda görüntülenecek karakterleri belirtir.',
	'currencySymbolLabel': 'Para birimi simgesi',
	'customSymbolPlaceholder': 'Bir simge ekle',
	'customSymbolLabelInfo': 'Özel bir simge olarak kullanılacak bir karakteri ya da karakterleri belirtir. Bu simge, sayıdan ve herhangi bir işaretten önce gelir.',
	'numberLabel': 'Sayı etiketi',
	'numberPositionLabel': 'Etiket konumu',
	'numberLabelInfo': 'Biçimlendirilmiş sayı için bir etiket belirtir ve etiket konumuna bağlı olarak önek veya sonek olarak yerleştirir.',
	'nullValueDefault': '<varsayılan>',
	'nullValueContent': '(değer yok)',
	'default': 'Varsayılan',
	'beginning': 'Başlangıç',
	'end': 'Bitiş',
	'formatLabel': 'Bir biçim seçin',

	// More data indicator
	'moreDataIndicator': 'Verileriniz %{threshold} öğeye ulaşıldığında kırpıldı. Daha az göstermek için bir süzgeç uygulayın.',

	// Expanded View / Focus mode
	'evCollapse': 'Daralt',
	'duplicate': 'Yinele',
	'copyOf': '%{name} kopyası',
	'unableToDuplicateBoard': '"%{name}" çoğaltılamıyor.',

	// Widget list
	'errorLoadingWidgetList': 'Nesneler yüklenemiyor.',

	// Custom widgets
	'customWidget': 'Özel pencere öğesi'
});
